import Bugsnag, { BreadcrumbType } from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import React from "react";
import { getUser, getVisitorId } from "./helperMethods";
import { APP_VERSION, CURRENT_USER } from "../constants";

const BugSnagTypes = { STATE: "state", ERROR: "error" };

export const bugSnagInititalize = () => {
  const isEnabledReleaseStage = Boolean(
    process.env.REACT_APP_BUG_SNAG_IS_ENABLED_RELEASE_STAGE
  );
  const enabledReleaseStages = isEnabledReleaseStage
    ? [process.env.REACT_APP_ENV]
    : [];

  Bugsnag.start({
    apiKey: isEnabledReleaseStage
      ? process.env.REACT_APP_BUG_SNAG_API_KEY
      : "noAPIKeyNeeded",
    plugins: [new BugsnagPluginReact()],
    onError: (event) => {
      let user = getUser();
      if( user.id ){
        event.setUser(
                        user.id ,
                        user.email !== null ? user.email : 'guest_email',
                        user.full_name !==  null ? user.full_name : 'GUEST_USER'
                      )
      }else{
        user = getVisitorId()  
        event.setUser(user, 'guest_email', 'GUEST_USER')
      }
      const errorClass = event?.errors[0]?.errorClass;
      const errorMessage = event?.errors[0]?.errorMessage;

      if (
        errorClass === 'ChunkLoadError' ||
        errorMessage.includes('Loading CSS chunk') ||
        errorMessage?.includes("Failed to load Stripe.js") ||
        errorMessage?.includes("Could not load \"util\"") ||
        errorMessage?.includes("Unable to preload CSS") ||
        errorMessage?.includes("ResizeObserver loop") ||
        errorMessage?.includes("Unexpected token") ||
        errorMessage?.includes("Can't find variable: HTMLDialogElement") ||
        errorMessage?.includes("Can't find variable: _AutofillCallbackHandler") ||
        errorMessage?.includes("Invalid call to runtime.sendMessage(). Tab not found.") ||
        errorMessage?.includes("Failed to fetch") ||
        errorMessage?.includes("window.webkit.messageHandler") ||
        errorMessage?.includes("Network Error") ||
        errorMessage?.includes('Blocked a frame with origin') ||
        errorMessage?.includes("Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.") ||
        errorMessage?.includes("Cannot read properties of null (reading 'removeChild')") ||
        errorMessage?.includes("Request aborted") ||
        errorMessage?.includes("Failed to fetch dynamically imported") ||
        errorMessage?.includes("unhandledrejection handler") ||
        errorMessage?.includes("Cannot read properties of null (reading 'scrollHeight')") ||
        errorMessage?.includes("null is not an object (evaluating 'e.parentNode.removeChild')") ||
        errorMessage?.includes("Cannot read properties of undefined (reading 'places')")
      )
      {
        return false; // Prevent Bugsnag from reporting this error
      }
      // if (
      //   errorMessage?.includes("Failed to fetch dynamically imported") ||
      //   errorMessage?.includes("unhandledrejection handler")
      // )
      // {
      //   Bugsnag.notify(
      //     new Error(`Error occurred due to ${errorMessage}`),
      //     (bugsnagEvent) => {
      //       bugsnagEvent.addMetadata(errorMessage, {
      //         reason: JSON.stringify(event),
      //         type: typeof event
      //       });
      //     });
      //   return false;
      // }
    },
    enabledReleaseStages,
    releaseStage: process.env.REACT_APP_ENV,
    appVersion: APP_VERSION,
  });
  return Bugsnag.getPlugin("react").createErrorBoundary(React);
};

export const bugSnagNotifyAPIError = (
  apiName: string,
  requestPayload: Object,
  responseErrorMessage: string
) => {
  if(responseErrorMessage !== 'Network Error'){
    Bugsnag.leaveBreadcrumb(
      `Failed API: ${apiName}`,
      requestPayload,
      BugSnagTypes.ERROR as BreadcrumbType
    );
    Bugsnag.notify(new Error(responseErrorMessage)); 
  }else{
    // remove the 'Failed Api' word form the log message if network error occur 
    Bugsnag.leaveBreadcrumb(
      apiName ,
      requestPayload,
      BugSnagTypes.ERROR as BreadcrumbType
    );
  }
};
